export default "__VITE_ASSET__CJvCeIXa__";